import { ALL_MONOSPACE_FONTS } from '@gitbook/app-database';

import type { SiteOnlyCustomizationProps } from '../../types';
import { AbstractFontSettings } from './AbstractFontSettings';

/**
 * Settings to configure the monospace font used in code blocks.
 */
export function MonoFontSettings(props: SiteOnlyCustomizationProps) {
    const { setSettings, settings } = props;
    return (
        <AbstractFontSettings
            {...props}
            defaultFonts={ALL_MONOSPACE_FONTS}
            font={settings.styling.monospaceFont}
            setFont={(font) =>
                setSettings((prev) => ({
                    ...prev,
                    styling: { ...prev.styling, monospaceFont: font },
                }))
            }
            label="Monospace font"
        />
    );
}
